import type { SchemaColumn, SchemaField } from '@cli-types/core-engine/schema.js'
import { renderImageCellMediaRenderer } from '@next-adapter/templates/renderers/generators/columns/column-defs/generate-image-cell-media.js'
import { buildImageUrlExpression } from './build-image-url-expression.js'
import { generateImageElement } from './generate-image-element.js'
import { generateTitleFallback } from './generate-title-fallback.js'

export function generateImageCellMedia(
  column: SchemaColumn,
  fields: SchemaField[],
  valueExpression: string,
  options: { selectable?: boolean } = {}
): string {
  const imageUrlExpression = buildImageUrlExpression(column, fields, valueExpression)
  const titleFallback = generateTitleFallback(fields)
  const imageElement = generateImageElement(column)

  if (options.selectable) {
    return renderImageCellMediaRenderer({
      kind: 'renderImageCellMediaLayoutTemplate',
      props: {
        imageUrlExpression: imageUrlExpression,
        titleFallback: titleFallback,
        split: imageElement.split('\n').join('\n          ')
      }
    })
  }

  return renderImageCellMediaRenderer({
    kind: 'renderImageCellMediaTemplate',
    props: {
      imageUrlExpression: imageUrlExpression,
      titleFallback: titleFallback,
      imageElement: imageElement
    }
  })
}
